export const API_CUSTOM_BASE_URL = "https://stag.erp.laundritek.net/api/v2/method";  
export const API_BASE_URL = "https://stag.erp.laundritek.net";